import gsap from "gsap";
import {
  ScrollTrigger
} from "gsap/ScrollTrigger";

import {
  detectPosition
} from "./detectposition";
import {
  bgViewer
} from "./bg-viewer";

import {
  resourcesView
} from "../modules/barba/barba-helpers";
import {
  objectOrientation,
  sidePanelOpen,
  sidePanelClose,
  applyGradientLine
} from "./helpers";
import {
  initLottie
} from "../../../includes/lottie/lottie";

export function homeUi(container) {

  console.log('homeUi', container);
  // instead of document - should this not be refering to the container? - review if issues arise
  let sideLinks = document.querySelectorAll('.side-link');
  let body = document.querySelector('body');
  let gradientLineContainer = document.querySelector('.line-container');
  let gradientLine = gradientLineContainer.querySelector('.line');
  // let sidePanel = document.querySelector('.side-panel');
  let sidePanel = document.querySelector('.side-panel.side-panel--home');

  let sidePanelToggleArea = document.querySelector('.side-panel__toggle-area');

  let sidePanelActiveLink = sidePanel.getAttribute('data-active-link'); // this will be idle initially
  let sidePanelState = sidePanel.getAttribute('data-side-panel-state'); // this will be closed initially

  let detectPositionTarget = document.querySelector('.detect-position__target'); // if just sthe text area
  let viewerBg = document.querySelector('#bg-viewer');
  // let detectPositionTarget = document.querySelector('#bg-viewer'); // review - but this is the whole area

  let sidePanelContentResources = sidePanel.querySelector('.panel__content[data-panel-content="resources"]');

  let resourceCategoriesUl = sidePanel.querySelector('.panel__body[data-resource-content="archive"] ul');


  sideLinks.forEach((item) => {

    //append svg code to each link
    // this copeied from icon file - update accordingly
    let svg = `<div class="svg__icon open-close-cross">
    
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g id="Group_73" data-name="Group 73" transform="translate(16.295 16.294) rotate(180)">
          <g id="Exclusion_1" data-name="Exclusion 1" transform="translate(0.295 0.294)" fill="none">
            <path d="M8,16A8,8,0,0,1,2.343,2.343,8,8,0,0,1,13.657,13.657,7.948,7.948,0,0,1,8,16ZM7.623,8.369v2.2h.9v-2.2h2.292V7.518H8.526V5.333h-.9V7.518H5.334v.851Z" stroke="none"/>
            <path d="M 8.000060081481934 15 C 9.869939804077148 15 11.62782955169678 14.27194023132324 12.94991016387939 12.94995975494385 C 14.27192974090576 11.62798976898193 15 9.870180130004883 15 8.000329971313477 C 15 6.130489826202393 14.27190017700195 4.372489929199219 12.94991970062256 3.050270080566406 C 11.62769031524658 1.728129982948303 9.869799613952637 1 8.000060081481934 1 C 6.130239963531494 1 4.372310161590576 1.728129982948303 3.050169944763184 3.050179958343506 C 1.728099942207336 4.372489929199219 1 6.130489826202393 1 8.000329971313477 C 1 9.870180130004883 1.728070020675659 11.62798976898193 3.050080060958862 12.94995021820068 C 4.372169971466064 14.27194023132324 6.130099773406982 15 8.000060081481934 15 M 6.622590065002441 9.369389533996582 L 4.333570003509521 9.369389533996582 L 4.333570003509521 6.517940044403076 L 6.622590065002441 6.517940044403076 L 6.622590065002441 4.333439826965332 L 9.525629997253418 4.333439826965332 L 9.525629997253418 6.517940044403076 L 11.81766986846924 6.517940044403076 L 11.81766986846924 9.369389533996582 L 9.525629997253418 9.369389533996582 L 9.525629997253418 11.56595993041992 L 6.622590065002441 11.56595993041992 L 6.622590065002441 9.369389533996582 M 8.000060081481934 16 C 5.863039970397949 16 3.854000091552734 15.1679801940918 2.342999935150146 13.65707969665527 C 0.8320500254631042 12.14618968963623 0 10.13722038269043 0 8.000329971313477 C 0 5.863550186157227 0.8320500254631042 3.854360103607178 2.342999935150146 2.343139886856079 C 3.8541100025177 0.8321300148963928 5.863090038299561 0 8.000060081481934 0 C 10.1369104385376 0 12.14589023590088 0.8321300148963928 13.6569995880127 2.343139886856079 C 15.16794967651367 3.854360103607178 16 5.863550186157227 16 8.000329971313477 C 16 10.13722038269043 15.16794967651367 12.14618968963623 13.6569995880127 13.65707969665527 C 12.14599990844727 15.1679801940918 10.13696002960205 16 8.000060081481934 16 Z M 5.333570003509521 7.517940044403076 L 5.333570003509521 8.369389533996582 L 7.622590065002441 8.369389533996582 L 7.622590065002441 10.56595993041992 L 8.525629997253418 10.56595993041992 L 8.525629997253418 8.369389533996582 L 10.81766986846924 8.369389533996582 L 10.81766986846924 7.517940044403076 L 8.525629997253418 7.517940044403076 L 8.525629997253418 5.333439826965332 L 7.622590065002441 5.333439826965332 L 7.622590065002441 7.517940044403076 L 5.333570003509521 7.517940044403076 Z" stroke="none" fill="#000"/>
          </g>
        </g>
      </svg>
    
    </div>`;
    item.insertAdjacentHTML('beforeend', svg);


    item.addEventListener('click', function (event) {
      let linkTarget = event.target.getAttribute('data-side-link'),
        sidePanelState = sidePanel.getAttribute('data-side-panel-state'),
        item = event.target;
      // console.log(linkTarget, "linkTarget");

      if (linkTarget == "resources") {
        let resourcesCategory = event.target.getAttribute('data-link-category');
        // console.log("resourcesCategory", resourcesCategory);

        // 
        if (resourcesCategory !== null) {

          resourceCategoriesUl.querySelector(`[data-body-nav-link="${resourcesCategory}"]`).click();

          // console.log("clicked on active category assigned", resourcesCategory);

        } else {
          // console.log("no active category assigned - is main link?]");
          // console.log(resourceCategoriesUl.querySelectorAll(`[data-body-nav-link].--active`));

          if (resourceCategoriesUl.querySelectorAll(`[data-body-nav-link].--active`).length > 0) {

            // console.log("active category exists - so click on that - to ensure the main category is shown");

            resourceCategoriesUl.querySelector(`[data-body-nav-link].--active`).click();
            // resourceCategoriesUl.querySelector(`[data-body-nav-link="${resourcesCategory}"]`).click();

          }

        }


      }

      if (item.classList.contains("--active")) {
        // this item is already active - so we need to close the side panel
        // console.log("item is not active anymore", item);
        //update var?
        sidePanelState = "open";
        // console.log("sidePanelState", sidePanelState);

        sidePanelView(sideLinks, gradientLine, sidePanel, linkTarget, sidePanelState);
        item.classList.remove("--active");

      } else {
        // console.log("item is active", item);
        // this item is not active - so we need to open the side panel
        // but only if its not already open

        // turn of all other active links
        sideLinks.forEach((item) => {
          item.classList.remove("--active");
        });

        if (sidePanelState == "open" || sidePanelState == "already-open") {
          //update var
          // console.log("sidePanelState", sidePanelState, "is open - so we just need to filter the view");
          sidePanelState = "already-open";

        } else {
          //update var
          sidePanelState = "closed";
        }
        // we now either open side panel 
        //or, if its already open- just filter the view

        sidePanelView(sideLinks, gradientLine, sidePanel, linkTarget, sidePanelState);
        //add this item as active
        item.classList.add("--active");
      }

    });

  });

  sidePanelToggleArea.addEventListener('click', function (event) {
    // console.log("sidePanelToggleArea", sidePanelToggleArea);
    // when click this - the panel closes

    // i don't think there'se any other considerations here?
    sidePanelClose(sideLinks, gradientLine, sidePanel);

  });



  // inititalise lottie animations
  initLottie(container);

  // resourceCategoriesUl panel orientation
  // objectOrientation(resourceCategoriesUl);// I think just get rid off - keep orienation the same: vertical = stacked

  // detect user position - review this in conjuction with the bg-viewer!?
  // temp or permanently remove this positiong thing!
  // detectPosition(detectPositionTarget, viewerBg); // start this after the view has loaded?!
  


  // review this because the home ui function as the name suggests should only be for the home page
  // but  I need to run the viewer on all pages - and then then probably run the the detect position on all pages too
  // plan this js sequence stuff in miro!!!



  // console.log("sidePanelContentResources;", sidePanelContentResources);

  // Resources UI
  if (sidePanelContentResources.toString().length > 0) {
    // console.log("sidePanelContentResources exists", sidePanelContentResources);
    let type = "home";

    resourcesView(sidePanelContentResources, type);
    // resourcesView(resources); // review using of var
  }

  // Initialize the scroll trigger
  const cleanupScrollTrigger = homeScrollTrigger(container);

  // Return the cleanup function
  return () => {
    if (cleanupScrollTrigger) {
      cleanupScrollTrigger();
    }
    console.log("homeUi cleanup complete");
  };
    

}


export function sidePanelView(sideLinks, gradientLine, sidePanel, linkTarget, sidePanelState) {
  // this function degermines what happens when:
  // - a user clicks on a side link
  //- is programmatically assigned (maybe after a page change for example) - review this... (maybe not ndeeded)
  // console.log("gradientLine", gradientLine);
  // console.log("sidePanelView", linkTarget);
  console.log("sidePanelState", sidePanelState);

  if (sidePanelState == "closed") {
    // console.log("sidePanelState", sidePanelState, "is closed - and will now open");
    //update var - and open panel
    // sidePanelState = "open";
    // open panel

    sidePanelOpen(sidePanel);
    applyGradientLine(gradientLine, linkTarget);
 
    sidePanel.setAttribute('data-active-link', linkTarget);

  } else if (sidePanelState == "open") {

    // console.log("sidePanelState", sidePanelState, "is open and now closes");

    //update var and close panel
    // sidePanelState = "closed";
    linkTarget = "--idle" // review!
    //close panel
    sidePanelClose(sideLinks, gradientLine, sidePanel)
    //set gradientLine to idle?
    applyGradientLine(gradientLine, linkTarget);

    // if we are closing it - should be set active-link back to idle?:
    setTimeout(function () {
      sidePanel.setAttribute('data-active-link', "idle"); //reivew - I should delay this - so that we can see the active panel content still when it coles
    }, 1000); // this causes some issues atm - review timing or ensure no "double clicking shit" happens

  } else if (sidePanelState == "already-open") {
    // console.log("sidePanelState", sidePanelState, "is already open - so keep it open");

    applyGradientLine(gradientLine, linkTarget);
    sidePanel.setAttribute('data-active-link', linkTarget);

    // review this in conjuction witht the different catefories for resources!
    // we need to filter the content of the side panel - and not have each link open a new panel
  }

}

// export function initGradientLine(gradientLine) {


//    console.log("gradientLine", gradientLine, "is loading");

//   gradientLine.classList.add("--loaded");

//   // //review this -! becasue we need to check if the linkTarget is idle or not
//   // if (gradientLine.classList.contains("--idle")) {
//   //   gradientLine.classList.remove("--idle");
//   //   gradientLine.classList.add("--active");

//   // } else {


//   // }

//   // // } else {


//   // //   gradientLine.classList.remove("active");
//   // //   gradientLine.classList.add("idle");

//   // //  }



// }


export function homeScrollTrigger(container) {
  gsap.registerPlugin(ScrollTrigger);

  // Select the elements
  const textElement = container.querySelector(".article__content");
  const imageElement = document.querySelector("#bg-viewer");
  const footerElement = document.querySelector("footer");

  imageElement.style.opacity = 1; // Ensure visibility on load (should fade in)

  // Check if a saved scroll position exists
  const savedScrollPosition = parseFloat(document.body.dataset.scrollPosition) || 0;

  // If there's a saved scroll position, scroll to it
  if (savedScrollPosition > 0) {
    window.scrollTo(0, savedScrollPosition);
  }

  // Create the scroll trigger
  const scrollTrigger = ScrollTrigger.create({
    trigger: "html",
    start: "top top",
    end: "bottom bottom",
    scrub: true,
    onUpdate: (self) => {
      const progress = self.progress;

      // Update opacity of the text and image based on scroll progress
      gsap.to(textElement, {
        opacity: progress,
        overwrite: true,
      });
      gsap.to(footerElement, {
        opacity: progress,
        overwrite: true,
      });
      gsap.to(imageElement, {
        opacity: 1 - progress,
        overwrite: true,
      });

      // Save the current scroll position in the body data attribute
      document.body.dataset.scrollPosition = window.scrollY;
    },
  });

  // Handle user interaction
  let userInteracted = false;

  const interactionHandler = () => {
    userInteracted = true;
    clearTimeout(timeout); // Clear the timeout if the user interacts
  };

  // Listen for user interactions (mouse, touch, and keyboard)
  const listeners = [
    ["scroll", interactionHandler],
    ["click", interactionHandler],
    ["keydown", interactionHandler],
    ["touchstart", interactionHandler],
    ["pointerdown", interactionHandler],
  ];
  listeners.forEach(([event, handler]) => {
    window.addEventListener(event, handler, { once: true });
  });

  // Set a timeout to auto-scroll if no interaction occurs
  const timeout = setTimeout(() => {
    if (!userInteracted) {
      const headerHeight = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue("--header-height")
      ) || 0;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const targetScroll = savedScrollPosition || maxScroll - headerHeight;

      gsap.to(window, {
        scrollTo: {
          y: targetScroll,
        },
        duration: 3,
      });
    }
  }, 6000); // Wait 6 seconds before triggering auto-scroll

  // Cleanup function to terminate ScrollTrigger and event listeners
  function cleanup() {
    scrollTrigger.kill(); // Kill the ScrollTrigger instance
    clearTimeout(timeout); // Clear the timeout
    listeners.forEach(([event, handler]) => {
      window.removeEventListener(event, handler); // Remove all event listeners
    });
  }

  // Return the cleanup function
  return cleanup;
}